import Vue from 'vue'
import Router from 'vue-router'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Containers
import Main from '@/containers/Main'
import UserList from '@/views/admin/user/List'
import UserForm from '@/views/admin/user/Form'
import RoleList from '@/views/admin/role/List'
import RoleForm from '@/views/admin/role/Form'
import PermissionList from '@/views/admin/permission/List'
import PermissionForm from '@/views/admin/permission/Form'
import ClientList from '@/views/admin/client/List'
import ClientForm from '@/views/admin/client/Form'
import MasterGroupList from '@/views/admin/inventory/master_group/List'
import MasterGroupForm from '@/views/admin/inventory/master_group/Form'
import MasterTypeList from '@/views/admin/inventory/master_type/List'
import MasterTypeForm from '@/views/admin/inventory/master_type/Form'
import MasterAccountList from '@/views/admin/inventory/master_account/List'
import MasterAccountForm from '@/views/admin/inventory/master_account/Form'
import MasterMaterialList from '@/views/admin/inventory/master_material/List'
import MasterMaterialForm from '@/views/admin/inventory/master_material/Form'
import MasterMaterialDetailList from '@/views/admin/inventory/master_material_detail/List'
import MasterMaterialDetailForm from '@/views/admin/inventory/master_material_detail/Form'
import MasterSupplierList from '@/views/admin/inventory/master_supplier/List'
import MasterSupplierForm from '@/views/admin/inventory/master_supplier/Form'
import MasterUomForm from '@/views/admin/inventory/master_uom/Form'
import MasterUomList from '@/views/admin/inventory/master_uom/List'
import MasterUomDetailForm from '@/views/admin/inventory/master_uom_detail/Form'
import MasterUomDetailList from '@/views/admin/inventory/master_uom_detail/List'
import MasterGenstoreForm from '@/views/admin/inventory/master_genstore/Form'
import MasterGenstoreList from '@/views/admin/inventory/master_genstore/List'
import MasterRecipeForm from '@/views/admin/inventory/master_recipe/Form'
import MasterRecipeList from '@/views/admin/inventory/master_recipe/List'
import MasterMaterialDetailSupplierForm from '@/views/admin/inventory/master_material_detail_supplier/Form'
import MasterMaterialDetailSupplierList from '@/views/admin/inventory/master_material_detail_supplier/List'
import MasterMaterialRecipeMappingForm from '@/views/admin/inventory/master_material_recipe_mapping/Form'
import MasterMaterialRecipeMappingList from '@/views/admin/inventory/master_material_recipe_mapping/List'
import SyncMasterForm from '@/views/admin/inventory/sync_master/Form'
import SyncMasterList from '@/views/admin/inventory/sync_master/List'
import SyncMasterDetailList from '@/views/admin/inventory/sync_master_detail/List'

// Views
import Dashboard from '@/views/Dashboard'
import Report from '@/views/Report'
import SalesHistory from '@/views/SalesHistory'
import ProductMix from '@/views/ProductMix'
import OrderProcessingTime from '@/views/OrderProcessingTime'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'

// Views - Admin
import Login from '@/views/admin/Login'
import Logout from '@/views/admin/Logout'

Vue.use(Router)
Vue.use(VueAxios, axios)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {auth: false}
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/',
      name: 'home',
      component: Main,
      meta: {
        label: 'home'
      },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            auth: true,
            label: 'dashboard'
          }
        },
        {
          path: 'sales-history',
          name: 'sales_history',
          component: SalesHistory,
          meta: {
            auth: true,
            label: 'sales_history'
          }
        },
        {
          path: 'product-mix',
          name: 'product_mix',
          component: ProductMix,
          meta: {
            auth: true,
            label: 'product_mix'
          }
        },
        {
          path: 'order-processing-time',
          name: 'order_processing_time',
          component: OrderProcessingTime,
          meta: {
            auth: true,
            label: 'order_processing_time'
          }
        },
        {
          path: 'report',
          name: 'report',
          component: Report,
          meta: {
            auth: {roles: ['report']},
            label: 'report'
          }
        },
        {
          path: 'user',
          redirect: '/user',
          name: 'user',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'user'
          },
          children: [
            {
              path: '/',
              name: 'user_list',
              component: UserList,
              meta: {
                // auth: {roles: ['user.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:uuid',
              props: true,
              name: 'user_edit',
              component: UserForm,
              meta: {
                // auth: {roles: ['user.update', 'user.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'user_create',
              component: UserForm,
              meta: {
                // auth: {roles: ['user.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'role',
          redirect: '/role',
          name: 'role',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'role'
          },
          children: [
            {
              path: '/',
              name: 'role_list',
              component: RoleList,
              meta: {
                // auth: {roles: ['role.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:uuid',
              props: true,
              name: 'role_edit',
              component: RoleForm,
              meta: {
                // auth: {roles: ['role.update', 'role.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'role_create',
              component: RoleForm,
              meta: {
                // auth: {roles: ['user.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'permission',
          redirect: '/permission',
          name: 'permission',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'permission'
          },
          children: [
            {
              path: '/',
              name: 'permission_list',
              component: PermissionList,
              meta: {
                auth: {roles: ['permission.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:uuid',
              props: true,
              name: 'permission_edit',
              component: PermissionForm,
              meta: {
                auth: {roles: ['permission.update', 'permission.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'permission_create',
              component: PermissionForm,
              meta: {
                auth: {roles: ['permission.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'client',
          redirect: '/client',
          name: 'client',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'client'
          },
          children: [
            {
              path: '/',
              name: 'client_list',
              component: ClientList,
              meta: {
                auth: {roles: ['client.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:uuid',
              props: true,
              name: 'client_edit',
              component: ClientForm,
              meta: {
                auth: {roles: ['client.update', 'client.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'client_create',
              component: ClientForm,
              meta: {
                auth: {roles: ['client.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-group',
          redirect: '/inventory/master-group',
          name: 'master_group',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_group'
          },
          children: [
            {
              path: '/',
              name: 'master_group_list',
              component: MasterGroupList,
              meta: {
                // auth: {roles: ['master_group.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_group_edit',
              component: MasterGroupForm,
              meta: {
                // auth: {roles: ['master_group.update', 'master_group.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_group_create',
              component: MasterGroupForm,
              meta: {
                // auth: {roles: ['master_group.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-type',
          redirect: '/inventory/master-type',
          name: 'master_type',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_type'
          },
          children: [
            {
              path: '/',
              name: 'master_type_list',
              component: MasterTypeList,
              meta: {
                // auth: {roles: ['master_type.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_type_edit',
              component: MasterTypeForm,
              meta: {
                // auth: {roles: ['master_type.update', 'master_type.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_type_create',
              component: MasterTypeForm,
              meta: {
                // auth: {roles: ['master_type.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-uom',
          redirect: '/inventory/master-uom',
          name: 'master_uom',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_uom'
          },
          children: [
            {
              path: '/',
              name: 'master_uom_list',
              component: MasterUomList,
              meta: {
                // auth: {roles: ['master_uom.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_uom_edit',
              component: MasterUomForm,
              meta: {
                // auth: {roles: ['master_uom.update', 'master_uom.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_uom_create',
              component: MasterUomForm,
              meta: {
                // auth: {roles: ['master_uom.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-uom-detail',
          redirect: '/inventory/master-uom-detail',
          name: 'master_uom_detail',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_uom_detail'
          },
          children: [
            {
              path: '/',
              name: 'master_uom_detail_list',
              component: MasterUomDetailList,
              meta: {
                // auth: {roles: ['master_uom_detail.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_uom_detail_edit',
              component: MasterUomDetailForm,
              meta: {
                // auth: {roles: ['master_uom_detail.update', 'master_uom_detail.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_uom_detail_create',
              component: MasterUomDetailForm,
              meta: {
                // auth: {roles: ['master_uom_detail.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-account',
          redirect: '/inventory/master-account',
          name: 'master_account',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_account'
          },
          children: [
            {
              path: '/',
              name: 'master_account_list',
              component: MasterAccountList,
              meta: {
                // auth: {roles: ['master_account.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_account_edit',
              component: MasterAccountForm,
              meta: {
                // auth: {roles: ['master_account.update', 'master_account.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_account_create',
              component: MasterAccountForm,
              meta: {
                // auth: {roles: ['master_account.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-material',
          redirect: '/inventory/master-material',
          name: 'master_material',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_material'
          },
          children: [
            {
              path: '/',
              name: 'master_material_list',
              component: MasterMaterialList,
              meta: {
                // auth: {roles: ['master_material.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_material_edit',
              component: MasterMaterialForm,
              meta: {
                // auth: {roles: ['master_material.update', 'master_material.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_material_create',
              component: MasterMaterialForm,
              meta: {
                // auth: {roles: ['master_material.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-material-detail',
          redirect: '/inventory/master-material-detail',
          name: 'master_material_detail',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_material_detail'
          },
          children: [
            {
              path: '/',
              name: 'master_material_detail_list',
              component: MasterMaterialDetailList,
              meta: {
                // auth: {roles: ['master_material_detail.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_material_detail_edit',
              component: MasterMaterialDetailForm,
              meta: {
                // auth: {roles: ['master_material_detail.update', 'master_material_detail.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_material_detail_create',
              component: MasterMaterialDetailForm,
              meta: {
                // auth: {roles: ['master_material_detail.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-supplier',
          redirect: '/inventory/master-supplier',
          name: 'master_supplier',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_supplier'
          },
          children: [
            {
              path: '/',
              name: 'master_supplier_list',
              component: MasterSupplierList,
              meta: {
                // auth: {roles: ['master_supplier.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_supplier_edit',
              component: MasterSupplierForm,
              meta: {
                // auth: {roles: ['master_supplier.update', 'master_supplier.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_supplier_create',
              component: MasterSupplierForm,
              meta: {
                // auth: {roles: ['master_supplier.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-genstore',
          redirect: '/inventory/master-genstore',
          name: 'master_genstore',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_genstore'
          },
          children: [
            {
              path: '/',
              name: 'list',
              component: MasterGenstoreList,
              meta: {
                // auth: {roles: ['master_genstore.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_genstore_edit',
              component: MasterGenstoreForm,
              meta: {
                // auth: {roles: ['master_genstore.update', 'master_genstore.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_genstore_create',
              component: MasterGenstoreForm,
              meta: {
                // auth: {roles: ['master_genstore.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-recipe',
          redirect: '/inventory/master-recipe',
          name: 'master_recipe',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_recipe'
          },
          children: [
            {
              path: '/',
              name: 'list',
              component: MasterRecipeList,
              meta: {
                // auth: {roles: ['master_recipe.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'master_recipe_edit',
              component: MasterRecipeForm,
              meta: {
                // auth: {roles: ['master_recipe.update', 'master_recipe.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_recipe_create',
              component: MasterRecipeForm,
              meta: {
                // auth: {roles: ['master_recipe.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-material-detail-supplier',
          redirect: '/inventory/master-material-detail-supplier',
          name: 'master_material_detail_supplier',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_material_detail_supplier'
          },
          children: [
            {
              path: '/',
              name: 'master_material_detail_supplier_list',
              component: MasterMaterialDetailSupplierList,
              meta: {
                // auth: {roles: ['master_material_detail_supplier.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:material_detail_id',
              props: true,
              name: 'master_material_detail_supplier_edit',
              component: MasterMaterialDetailSupplierForm,
              meta: {
                // auth: {roles: ['master_material_detail_supplier.update', 'master_material_detail_supplier.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_material_detail_supplier_create',
              component: MasterMaterialDetailSupplierForm,
              meta: {
                // auth: {roles: ['master_material_detail_supplier.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/master-material-recipe-mapping',
          redirect: '/inventory/master-material-recipe-mapping',
          name: 'master_material_recipe_mapping',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'master_material_recipe_mapping'
          },
          children: [
            {
              path: '/',
              name: 'master_material_recipe_mapping_list',
              component: MasterMaterialRecipeMappingList,
              meta: {
                // auth: {roles: ['master_material_recipe_mapping.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:material_recipe_mapping_id',
              props: true,
              name: 'master_material_recipe_mapping_edit',
              component: MasterMaterialRecipeMappingForm,
              meta: {
                // auth: {roles: ['master_material_recipe_mapping.update', 'master_material_recipe_mapping.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'master_material_recipe_mapping_create',
              component: MasterMaterialRecipeMappingForm,
              meta: {
                // auth: {roles: ['master_material_recipe_mapping.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/sync-master',
          redirect: '/inventory/sync-master',
          name: 'sync_master',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'sync_master'
          },
          children: [
            {
              path: '/',
              name: 'sync_master_list',
              component: SyncMasterList,
              meta: {
                // auth: {roles: ['sync_master.list']},
                label: 'list'
              }
            },
            {
              path: 'edit/:id',
              props: true,
              name: 'sync_master_edit',
              component: SyncMasterForm,
              meta: {
                // auth: {roles: ['sync_master.update', 'sync_master.detail']},
                label: 'edit'
              }
            },
            {
              path: 'create',
              name: 'sync_master_create',
              component: SyncMasterForm,
              meta: {
                // auth: {roles: ['sync_master.create']},
                label: 'create'
              }
            }
          ]
        },
        {
          path: 'inventory/sync-master-detail',
          redirect: '/inventory/sync-master-detail',
          name: 'sync_master_detail',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta: {
            label: 'sync_master_detail'
          },
          children: [
            {
              path: '/',
              name: 'sync_master_detail_list',
              component: SyncMasterDetailList,
              meta: {
                // auth: {roles: ['sync_master_detail.list']},
                label: 'list'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '403',
          name: 'Page403',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js